export default "__VITE_ASSET__DyoUN41n__"